// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS = [
	'confluence.ssr.page-statuses',
	'confluence.frontend.fabric.editor.macro.adf.frontend.render',
	'company_hub_beta',
	'analytics-next-use-modern-context_jira',
	'confluence_ssr_enable_tesseract_stream_endpoint',
	'confluence_frontend_livepages_fastloading',
	'change_smartlinks_ssr_loading_scheme',
	'confluence_use_parcel',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS = [];
